module.exports = __webpack_public_path__ + "static/media/photographycarry01.a60fbb00.png";